import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { CloudHelpers } from "@/core/modules/helpers/CloudHelpers";

export const isPeriodAvailable = async (companyId: string, from: Date, to: Date | undefined, companyPriceListId = "empty"): Promise<boolean> => {
  try {
    if (companyId === undefined) return false;
    if (from === undefined) return false;

    return CloudHelpers.runValidatorFunction(
      "featuresCompanyPriceListPeriodValidator",
      { companyId: companyId, from: from.getTime(), to: to?.getTime() ?? null },
      companyPriceListId
    );
  } catch (error: unknown) {
    appFaultModel.catchAppError("CompanyPriceListModel.isPeriodAvailable", { companyId, from, to, companyPriceListId }, error);
    return false;
  }
};
